import { useQuery } from 'hooks/useCustomQuery';
import getSRTService from 'API/SRT/getSRTService';

/**
 * The SRT service being edited.
 *
 * @param {object} params
 * @param {string} params.id Service id from the route.
 */
const useGetSRTService = ({ id }) => {
    return useQuery({
        queryKey: ['srtServiceData', id],
        queryFn: async () => {
            const result = await getSRTService(id);
            return result.data;
        },
        enabled: Boolean(id),
    });
};

export default useGetSRTService;
